/* eslint-disable tailwindcss/no-custom-classname */

import type { PropsOf } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';
import classnames from 'classnames';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';
import { useToastStyles } from '../Toast/Toast.context';

export type ToastBodyProps = OmitChakraProps<PropsOf<'div'>>;

export const ToastBody = withChakraAs<ToastBodyProps, 'div'>(
  ({ className, ...props }) => {
    const styles = useToastStyles();

    return (
      <chakra.div
        {...props}
        className={classnames('toast-body', className)}
        __css={styles.body}
      />
    );
  },
);
